<footer class="footer-area">
    <div class="container">
        <h3><a routerLink="/"><span>Pafar</span></a></h3>
        <ul>
            <li><a href="https://www.linkedin.com/company/pafaringenieriayconstruccion/" target="_blank" rel="noopener noreferrer" class="fab fa-linkedin-in" aria-label="LinkedIn"></a></li>
        </ul>
        <p>{{ 'footer.copyright' | translate }}</p>
        <p>{{ 'footer.handmade' | translate }} <i class="fa-regular fa-heart ms-1"></i></p>
    </div>
</footer>

<ngx-scrolltop></ngx-scrolltop>
